import { Fragment, useState } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@components/atoms/Button';
import { Checkbox } from '@components/atoms/Checkbox';

import { translate } from '@utils/translations';

import * as S from './styles';
import { IProps } from './types';

export const AttributeValuesChecklist: React.FC<IProps> = ({
  // title,
  name,
  values,
  valuesShowLimit = false,
  valuesShowLimitNumber = 5,
  onValueClick,
}: IProps) => {
  const [viewAllOptions, setViewAllOptions] = useState(!valuesShowLimit);
  const intl = useIntl();
  return (
    <S.Wrapper>
      {/* {title && <S.Header>{title}</S.Header>} */}
      {values &&
        values.map((value, index) =>
          !viewAllOptions && index > valuesShowLimitNumber - 1 ? (
            <Fragment key={index} />
          ) : (
            <Checkbox
              key={value.id}
              name={name}
              checked={!!value.selected}
              onChange={() => onValueClick(value)}
            >
              {translate(value, 'name').replace('_', ' ')}
            </Checkbox>
          )
        )}
      {!viewAllOptions && values.length > valuesShowLimitNumber && (
        <S.ViewMoreButton>
          <Button
            appearance="ghost"
            size="sm"
            color="secondary"
            onClick={() => setViewAllOptions(true)}
          >
            {intl.formatMessage({
              defaultMessage: 'VIEW ALL OPTIONS',
              id: 'YQVUHR',
            })}
          </Button>
        </S.ViewMoreButton>
      )}
      <S.BottomBorder />
    </S.Wrapper>
  );
};

AttributeValuesChecklist.displayName = 'AttributeValuesChecklist';
